import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { getQueryParamsForSurface } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/tileUrlHelpers";
import { QueryParameters as BrandPageQueryParameters, path as brandPage } from "@faire/web-api--source/routes/brand/brandToken";
import { QueryParameters as ProductPageQueryParameters, path as productPage } from "@faire/web-api--source/routes/product/productToken";
import { useCallback } from "react";
import { useRouteMatch } from "react-router-dom";
export var useGenerateProductLinkPropsForSDUIProductTileHandler = function(productTile, display_page) {
    var location = useZustandLocation(function(state) {
        return state.search;
    });
    var match = useRouteMatch();
    return useCallback(function() {
        var product = productTile === null || productTile === void 0 ? void 0 : productTile.product;
        if (!(product === null || product === void 0 ? void 0 : product.token)) {
            return undefined;
        }
        var productPageParams = ProductPageQueryParameters.build({
            productOptionToken: productTile === null || productTile === void 0 ? void 0 : productTile.selected_product_option_token,
            impressionId: product.impression_id
        });
        if (display_page !== undefined) {
            var queryParams = getQueryParamsForSurface(display_page, location, match);
            productPageParams.refF = queryParams.refF;
            productPageParams.refC = queryParams.refC;
        }
        return {
            productUrl: productPage(product.token, productPageParams)
        };
    }, [
        display_page,
        match,
        location,
        productTile
    ]);
};
export var useGenerateBrandUrlForSDUIProductTileHandler = function(productTile, display_page) {
    var location = useZustandLocation(function(state) {
        return state.search;
    });
    var match = useRouteMatch();
    return useCallback(function() {
        var product = productTile === null || productTile === void 0 ? void 0 : productTile.product;
        var brandToken = product === null || product === void 0 ? void 0 : product.brand_token;
        if (!brandToken) {
            return undefined;
        }
        var brandPageParams = BrandPageQueryParameters.build({
            refP: product.token,
            impressionId: product.impression_id
        });
        if (display_page !== undefined) {
            var queryParams = getQueryParamsForSurface(display_page, location, match);
            brandPageParams.refF = queryParams.refF;
            brandPageParams.refC = queryParams.refC;
            brandPageParams.sortingHint = queryParams.sortingHint;
        }
        return brandPage(brandToken, brandPageParams);
    }, [
        display_page,
        match,
        location,
        productTile
    ]);
};
